import React from "react";
import { CircularProgress } from "@material-ui/core";
import "./ScanLoadingOverlay.css";

type ScanLoadingOverlayProps = {
  open: boolean;
  message?: string;
};

const ScanLoadingOverlay: React.FC<ScanLoadingOverlayProps> = ({
  open,
  message = "Escaneando documento...",
}) => {
  if (!open) return null;
  return (
    <div className="scanLoadingOverlay-root" role="status" aria-live="polite">
      <div className="scanLoadingOverlay-content">
        <CircularProgress size={64} thickness={4} />
        <div className="scanLoadingOverlay-text">{message}</div>
      </div>
    </div>
  );
};

export default ScanLoadingOverlay;
